import type { RootState } from 'reducers/types';

export const getPayouts = (state: RootState) => {
  const {
    entities: { payouts },
  } = state;
  return payouts;
};
